module.exports = __webpack_public_path__ + "img/about-us-zs-2.4fa2943f.png";